// APA 7th-edition reference strings — mirror of backend/src/utils/apa.js.
//
// Duplicated deliberately: the only client-side need is the live preview in the
// manual-entry form, and there is no shared package between frontend and
// backend to hold it. The server remains authoritative — every stored
// apa_formatted value is produced by the backend copy.
// ponytail: keep the two files identical; extract to a shared package only if a
// third consumer appears.

function clean(v) {
  return typeof v === 'string' ? v.trim() : (v == null ? '' : String(v))
}

// APA 7 wants "&" before the final author rather than "and".
function normaliseAuthors(authors) {
  const a = clean(authors)
  if (!a) return ''
  // Only the FINAL "and" becomes "&" — the lookahead rejects any candidate that
  // still has another " and " after it. An existing comma is absorbed so
  // "Smith, J., and Jones, M." does not end up with a doubled comma.
  return a
    .replace(/,?\s+and\s+(?![\s\S]*\s+and\s+)/i, ', & ')
    .replace(/\s{2,}/g, ' ')
}

// Titles end in exactly one period — sources routinely arrive with or without.
function terminate(s) {
  const t = clean(s)
  if (!t) return ''
  return /[.?!]$/.test(t) ? t : `${t}.`
}

function sourceLink({ doi, url }) {
  const d = clean(doi)
  if (d) return ` https://doi.org/${d.replace(/^https?:\/\/doi\.org\//i, '')}`
  const u = clean(url)
  return u ? ` ${u}` : ''
}

export function buildApa(ref = {}) {
  const authors = normaliseAuthors(ref.authors)
  const year    = clean(ref.year) || 'n.d.'
  const title   = clean(ref.title)
  const source  = clean(ref.journal)          // journal OR publisher, by type
  const link    = sourceLink(ref)
  const type    = clean(ref.type).toUpperCase() || 'JOURNAL'

  const head = [authors && terminate(authors), `(${year}).`].filter(Boolean).join(' ')

  // Books and reports: publisher stands where the journal would.
  if (type === 'BOOK' || type === 'REPORT') {
    return `${head} ${terminate(title)}${source ? ` ${terminate(source)}` : ''}${link}`.trim()
  }

  if (type === 'WEBSITE') {
    return `${head} ${terminate(title)}${source ? ` ${terminate(source)}` : ''}${link}`.trim()
  }

  // Journal articles: Journal, Volume(Issue), pages.
  const vol = clean(ref.volume)
  const iss = clean(ref.issue)
  const pgs = clean(ref.pages)

  let locator = source
  if (locator && vol) locator += `, ${vol}`
  if (locator && iss) locator += `(${iss})`
  if (pgs) locator = locator ? `${locator}, ${pgs}` : pgs

  return `${head} ${terminate(title)}${locator ? ` ${terminate(locator)}` : ''}${link}`.trim()
}

export default buildApa
